<template>
  <v-card
    v-if="selected"
    flat
    tile
  >
    <v-list
      :class="`transparent${dense ? ' py-0' : ''}`"
      :dense="dense"
    >
      <v-list-item
        class="px-0"
      >
        <v-list-item-content
          class="py-0"
          style="flex:1.6"
        >
          {{ currentLevel.length > 4 ? currentLevel.substring(0, currentLevel.length-1) : currentLevel }}
        </v-list-item-content>
        <v-list-item-content
          style="align-items:flex-end"
          class="py-0 pl-2 font-weight-bold text-body-2"
        >
          {{ selected.name }}
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="metric !== null"
        class="px-0"
      >
        <v-list-item-content
          class="py-0"
          style="flex:1.6"
        >
          {{ measureTitle }}
        </v-list-item-content>
        <v-list-item-content
          style="align-items:flex-end"
          class="py-0 pl-2 font-weight-bold text-body-2"
        >
          {{ metric.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}
        </v-list-item-content>
      </v-list-item>
      <template v-if="metric !== null && config.denominator.type !== 'none'">
        <v-list-item
          v-if="metric !== null"
          class="px-0"
        >
          <v-list-item-content
            class="py-0"
            style="flex:1.6"
          >
            {{ numeratorTitle }}
          </v-list-item-content>
          <v-list-item-content
            style="align-items:flex-end"
            class="py-0 pl-2 font-weight-bold text-body-2"
          >
            {{ selected.metric.numerator.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="metric !== null"
          class="px-0"
        >
          <v-list-item-content
            class="py-0"
            style="flex:1.6"
          >
            {{ denominatorTitle }}
          </v-list-item-content>
          <v-list-item-content
            style="align-items:flex-end"
            class="py-0 pl-2 font-weight-bold text-body-2"
          >
            {{ selected.metric.denominator.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <v-container
      v-if="metric === null"
      class="text-center px-5 my-4"
    >
      <v-alert
        :value="true"
        type="info"
        outlined
      >
        <div>Aucune information disponible</div>
      </v-alert>
    </v-container>
  </v-card>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    props: {
      dense: { type: Boolean, default: false },
    },
    computed: {
      ...mapState(['selected', 'currentLevel', 'numeratorValueField', 'denominatorValueField']),
      ...mapGetters(['config', 'measureTitle', 'numeratorField', 'denominatorField']),
      metric () {
        if (!this.selected) return null
        return (this.config.denominator.type !== 'none' && this.selected.metric.denominator) ? (this.selected.metric.numerator / this.selected.metric.denominator) : this.selected.metric.numerator
      },
      numeratorTitle () {
        let title = ''
        if (this.config.numerator.type === 'count') {
          title += 'Décompte'
        } else {
          title += this.numeratorValueField.label
        }
        if (this.numeratorField) title += ` (${this.numeratorField.title || this.numeratorField['x-originalName']} ${this.config.numerator.propertyValue})`
        return title
      },
      denominatorTitle () {
        let title = ''
        if (this.config.denominator.type === 'count') {
          title += 'Décompte'
        } else {
          title += this.denominatorValueField.label
        }
        if (this.denominatorField) title += ` (${this.denominatorField.title || this.denominatorField['x-originalName']} ${this.config.denominator.propertyValue})`
        return title
      },
    },
  }
</script>
